var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "facebook-logo-white_svg__svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#039be5",
    overflow: "hidden"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M767.429 6.857v150.857h-89.715q-49.143 0-66.285 20.572T594.286 240v108h167.428L739.43 517.143H594.286v433.714H419.429V517.143H273.714V348H419.43V223.429q0-106.286 59.428-164.858T637.143 0q84 0 130.286 6.857z"
  })));
}
export default SvgFacebookLogoWhite;